export interface AnalyticsData {
  controlName: string;
  value: unknown;
  error?: string;
}
